<template lang="pug">
.v-compare-table.compare-table(v-if="items && items.length" :class="{'compare-table--simple': simple}" :id="data?.id")
	.compare-table__title(v-if="data.title" v-html="data.title")
	v-loader(:loading="loading")
	.compare-table__cards(v-if="items && simple && isTablet")
		.compare-table__cards-head
			.compare-table__card-head(v-for="item in items" :key="item.id") {{handleCuttinTextWidth(item.title)}}
				span.compare-table__card-head-rate(v-if="item.rate") {{ item.rate }}
		.compare-table__cards-body
			.compare-table__card-body(v-for="item in items" :key="item.id")
				.compare-table__card-body-section(v-for="group in data.groups")
					.compare-table__card-title {{group.title}}
					template(v-if="group.items")
						.compare-table__card-row(v-for="row in group.items")
							.compare-table__card-text {{row.text}}
							.compare-table__card-value
								v-svg-icon.compare-table__card-value-icon.compare-table__card-value-icon--apply(v-if="getCellValue(item, group, row) === 'true'" icon="tik")
								span.compare-table__card-value-text(v-else="" v-html="getCellValue(item, group, row)")
								v-svg-icon.compare-table__card-value-icon(v-if="!getCellValue(item, group, row)" icon="minus")
	.compare-table__layout(v-else="")
		.compare-table__body
			.compare-table__head(:style="{'width': computedWidth}")
				.compare-table__tags.tags(v-if="isTablet")
					.tags__items
						.tags__item(v-for="(item, i) in items" :key="item.id" @click="currentSlide = i" :class="{'active': i === currentSlide}") {{item.title}}
				.compare-table__head-layout
					.compare-table__head-aside
					.compare-table__head-main(@touchstart="dragStart" @touchend="dragEnd" @touchmove="dragMove")
						button.swiper-arrow.swiper-button-prev.swiper-arrow--dark(type='button' @click='slideItemsBack' :class='{disabled: isPrevArrowDisabled()}')
							v-svg-icon.swiper-arrow__icon(icon="chevron-left")
						button.swiper-arrow.swiper-button-next.swiper-arrow--dark(type='button' @click='slideItemsForward' :class='{disabled: isNextArrowDisabled()}')
							v-svg-icon.swiper-arrow__icon(icon="chevron-right")
						.compare-table__head-hide-items(v-if="hideItems")
							.compare-table__head-hide-item(v-for="hideItem in hideItems" :key="hideItem.id")
								.compare-table__head-item-content
									.compare-table__head-item-checkbox
										v-field-checkbox(:field="{item: hideItem}" :model-value="false" @update:model-value="handleHideItem")
									.compare-table__head-hide-item-title {{hideItem.title}}
						.compare-table__head-items
							.compare-table__head-items-grid(:style="{'transform': `translate3d(${currentSlideOffset},0,0) translateX(${dragOffset}px)`, 'transition': computedTransition}")
								.compare-table__head-item(v-for="item in items" :key="item.id" :style="{'width': computedColWidth}")
									.compare-table__head-item-content
										v-sticker.compare-table__head-item-sticker(v-if="item.sticker" :data="item.sticker")
										.compare-table__head-item-checkbox
											v-field-checkbox(v-if="this.items.length > maxVisibleSlides" :field="{item}" :disabled="disableHideCheckbox" :model-value="true" @update:model-value="handleHideItem")
										.compare-table__head-item-title(v-if="item.title")
											| {{item.title}}
											span.compare-table__head-item-rate(v-if="item.rate") {{ item.rate }}
										.compare-table__head-item-text(v-if="item.text") {{item.text}}
										v-action.btn.compare-table__head-item-action(v-if="item.action" :action="item.action")
											span.compare-table__head-item-action-subtext(v-if="item.action.subtext") {{item.action.subtext}}
			.compare-table__body-grid(ref='compareBody' @touchstart='dragStart' @touchend='dragEnd' @touchmove='dragMove' :style="{'width': computedWidth}")
				.compare-table__grid(v-if="data.groups")
					.compare-table__grid-group(v-for='group in data.groups' :class="{'compare-table__grid-group--hidden': group.hidden}")
						.compare-table__grid-row(v-if="group.title")
							.compare-table__grid-aside
								.compare-table__grid-aside-content
									.compare-table__grid-group-title {{group.title}}
							.compare-table__grid-hide-items(v-if="hideItems")
								.compare-table__grid-hide-item(v-for="hideItem in hideItems")
									.compare-table__grid-main-cell
										.compare-table__grid-main-cell-content
							.compare-table__grid-main
								.compare-table__grid-main-grid(:style="{'transform': 'translate3d('+currentSlideOffset+',0,0) translateX('+dragOffset+'px)', 'transition': computedTransition}")
									.compare-table__grid-main-cell(v-for='item in items' :style="{'width': computedColWidth}")
										.compare-table__grid-main-cell-content
						.compare-table__grid-row(v-for='row in group.items')
							.compare-table__grid-aside
								.compare-table__grid-aside-content
									span(v-html="row.text")
									span.compare-table__grid-group-informer(v-if="row.info")
										v-informer(:info="{...row.info, closeText: data.closeText}")
									.compare-table__grid-aside-note {{row.note}}
							.compare-table__grid-hide-items(v-if="hideItems")
								.compare-table__grid-hide-item(v-for="hideItem in hideItems")
									.compare-table__grid-main-cell
										.compare-table__grid-main-cell-content
							.compare-table__grid-main
								.compare-table__grid-main-grid(:style="{'transform': 'translate3d('+currentSlideOffset+',0,0) translateX('+dragOffset+'px)', 'transition': computedTransition}")
									.compare-table__grid-main-cell(v-for='item in items' :key="item.id" :style="{'width': computedColWidth}")
										.compare-table__grid-main-cell-content
											v-svg-icon.compare-table__grid-main-cell-icon.compare-table__grid-main-cell-icon--apply(v-if="getCellValue(item, group, row) === 'true'" icon="tik")
											span.compare-table__grid-main-cell-text(v-else="" v-html="getCellValue(item, group, row)")
											v-svg-icon.compare-table__grid-main-cell-icon(v-if="!getCellValue(item, group, row)" icon="minus")
					.compare-table__grid-group(v-if="hiddenGroups && hiddenGroups.length")
						.compare-table__grid-row
							.compare-table__grid-aside
								.compare-table__grid-aside-content
									button.compare-table__grid-group-btn(type="button" @click="handlerShowAllGroups")
										.compare-table__grid-group-title {{data.showOtherText}}
										v-svg-icon.compare-table__group-title-arrow(icon="select-arrow")
							.compare-table__grid-hide-items(v-if="hideItems")
								.compare-table__grid-hide-item(v-for="hideItem in hideItems")
									.compare-table__grid-main-cell
										.compare-table__grid-main-cell-content
							.compare-table__grid-main
								.compare-table__grid-main-grid(:style="{'transform': 'translate3d('+currentSlideOffset+',0,0) translateX('+dragOffset+'px)', 'transition': computedTransition}")
									.compare-table__grid-main-cell(v-for='item in items' :style="{'width': computedColWidth}")
										.compare-table__grid-main-cell-content
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";
import isScrollToSelfMixin from '../components/mixins/v-mixin-scroll-to-self.vue';
import controller from '../scripts/controller/controller';

export default {
	props: {
		simple: {
			type: Boolean,
			default: false
		}
	},

	mixins: [
		sourceMixin,
		isMobMixin,
		isScrollToSelfMixin
	],

	data() {
		return {
			data: null,
			items: null,
			hiddenGroups: [],
			hideItems: [],
			rows: null,
			loading: false,
			currentSlide: 0,
			slidesToShow: 4,
			dragOn: false,
			dragStartPosition: undefined,
			dragOffsetReal: 0,
			dragOffset: 0,
			computedTransition: 'none',
			computedWidth: 'auto',
			widthOfItem: undefined,
			resizeTimeout: null
		};
	},

	watch: {
		hideItems: {
			handler() {
				this.setSlidesToShow();
			},
			deep: true
		},

		items: {
			handler() {
				if (this.items.length <= this.slidesToShow) {
					this.slidesToShow = this.items.length;
				}
			},
		},

		slidesToShow() {
			this.handleStretchingFullWidth()
		}
	},

	computed: {
		currentSlideOffset() {
			return -this.currentSlide * 100 / this.slidesToShow + '%';
		},

		itemsCount() {
			return this.items.length
		},

		computedColWidth() {
			return `${100 / this.slidesToShow}%`;
		},

		disableHideCheckbox() {
			return this.items.length <= this.slidesToShow || this.hideItems?.length >= this.maxHideSlides;
		},

		maxVisibleSlides() {
			return this.isMob ? 1 : (this.isSm ? 2 : (this.isTablet ? 3 : this.simple ? 5 : 4))
		},

		maxHideSlides() {
			return this.isMob ? 0 : (this.isSm ? 2 : (this.isTablet ? 5 : 7))
		}
	},

	mounted() {
		this.setSlidesToShow();
	},

	created() {
		window.addEventListener('resize', this.handleResize, controller.passiveEventsSupported ? {passive: true} : undefined);
	},

	unmounted() {
		window.removeEventListener('resize', this.handleResize);
	},

	methods: {

		dataSet(data) {
			this.data = {
				...data,
				groups: data.groups
			};
			this.items = data.items.map((item, i) => ({...item, order: i}));
			this.hiddenGroups = data.groups?.filter(group => group.hidden);
			//this.data.groups.push(...this.hiddenGroups);
		},

		slideItemsBack() {
			if (!this.isPrevArrowDisabled()) {
				this.currentSlide--;
			}
			this.computedTransition = 'transform .3s';
		},

		slideItemsForward() {
			if (!this.isNextArrowDisabled()) {
				this.currentSlide++;
			}
			this.computedTransition = 'transform .3s';
		},

		isPrevArrowDisabled() {
			return this.currentSlide === 0;
		},

		isNextArrowDisabled() {
			return this.currentSlide + this.slidesToShow >= this.itemsCount;
		},

		dragStart(e) {
			if (!this.isTablet) {
				return;
			}
			this.dragOn = true;
			this.dragStartPosition = e.touches[0].pageX;
			this.computedTransition = 'none';
			this.widthOfItem = this.$el.querySelector('.compare-table__head-item').offsetWidth;
		},

		dragEnd() {
			if (!this.isTablet) {
				return;
			}
			this.dragOn = false;
			this.computedTransition = 'transform .3s';
			this.currentSlide = Math.round((this.widthOfItem * this.currentSlide - this.dragOffset) / this.widthOfItem);
			if (this.currentSlide + this.slidesToShow >= this.itemsCount) {
				this.currentSlide = this.itemsCount - this.slidesToShow;
			}
			if (this.currentSlide < 0) {
				this.currentSlide = 0;
			}
			this.dragOffset = 0;
		},

		dragMove(e) {
			if (!this.dragOn) {
				return;
			}
			this.dragOffsetReal = e.touches[0].pageX - this.dragStartPosition;
			if (this.widthOfItem * this.currentSlide - this.dragOffsetReal < 0) {
				this.dragOffset = this.widthOfItem * this.currentSlide;
			} else {
				this.dragOffset = this.dragOffsetReal;
			}
		},

		getCellValue(item, group, row) {
			return item && group && row ? item.features.find(feature => group.id === feature.group && row.id === feature.id)?.text : null;
		},

		setSlidesToShow() {
			this.slidesToShow = this.hideItems.length > 0 ? (this.hideItems.length > 3 ? 2 : (this.isTablet ? 2 : 3)) : this.maxVisibleSlides;
		},

		handleHideItem(value, field) {
			if (value) {
				this.hideItems = this.hideItems.filter(item => item.id !== field.item.id);
				this.items = [...this.items.slice(0, field.item.order), field.item, ...this.items.slice(field.item.order)];
			} else if (!value) {
				this.items = this.items.filter(item => item.id !== field.item.id);
				this.hideItems.push(field.item);
				if (this.items.length + this.hideItems.length > this.currentSlide) {
					this.slideItemsBack()
				}
			}
		},

		handleResize() {
			clearTimeout(this.resizeTimeout);
			this.resizeTimeout = setTimeout(() => {
				this.setSlidesToShow();
			}, 500);
		},

		handlerShowAllGroups() {
			this.$nextTick(() => {
				this.hiddenGroups = [];
				let $hiddenGroups = this.$el.querySelectorAll('.compare-table__grid-group--hidden');
				if ($hiddenGroups && $hiddenGroups.length) {
					$hiddenGroups.forEach($hiddenGroup => {
						$hiddenGroup.classList.remove('compare-table__grid-group--hidden')
					});
				}
			});
		},

		handleStretchingFullWidth() {
			if (this.items?.length <= this.slidesToShow) {
				this.slidesToShow = this.items.length;
			}
		},

		handleCuttinTextWidth(value) {
			const words = value.split(' ');
			let newValue = ''
			for(let i = 0; i < words.length; i++) {
				let word = words[i]

				if(word.length > 12) {
					word = word.substring(0, 9) + '...'
				}

				if(i !== words.length - 1) {
					word += ' '
				}

				newValue += word
			}

			return newValue
		},
	}
};
</script>